import * as ActionTypes from '../actions/types'
import * as Actions from '../actions/actions'
import {requestCreator} from '../../../helpers/requestCreator'

const getUserPermissions = requestCreator({
    url: '/user/rights',
    method: 'GET',
    onSuccess: Actions.getCurrentUserPermissionsSucceeded,
    onFailure: Actions.getCurrentUserPermissionsFailed,
    // overrideTask: async () => ({
    //     data: require('./mock/permissions.json')
    // })
})

const requestHandler = {
    [ActionTypes.GET_USER_PERMISSIONS]: getUserPermissions
}

export default requestHandler